import { render, staticRenderFns } from "./ContentAdd.vue?vue&type=template&id=8d99090c&"
import script from "./ContentAdd.vue?vue&type=script&lang=js&"
export * from "./ContentAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports